import { useState } from "react";
import Cat from "../Models/Cat/Cat";
import pointerEvents from "../utils/pointerEvents";
import TextArrow from "../Arrow/TextArrow";
import Screen from "../Models/Screen/Screen";

export default function ProjectsArea() {
  const [isCatJumping, setIsCatJumping] = useState(false);

  const navigateToMiawketeer = () => {
    setIsCatJumping(true);
    setTimeout(() => {
      setIsCatJumping(false);
      window.open("https://miawketeer.mrizki.com", "_blank");
    }, 1000);
  };

  return (
    <group name="projects-area-route" scale={1.5} position={[0, 0.5, 0]}>
      <group name="miawketeer" position={[-1, 0, 0]}>
        <Cat
          {...pointerEvents}
          onClick={navigateToMiawketeer}
          position={[0.1, -1, 0]}
          rotation={[0, 2.5, 0]}
          isJumping={isCatJumping}
        />
        <TextArrow
          {...pointerEvents}
          onClick={navigateToMiawketeer}
          direction="DOWN"
          position={[0, -0.3, -0.2]}
          scale={1}
        >
          Miawketeer
        </TextArrow>
      </group>

      <group name="mrmovie" position={[0.5, 0, 0]}>
        <Screen
          {...pointerEvents}
          position={[0, -1, 0]}
          scale={0.3}
          castShadow
          receiveShadow
          onClick={() => window.open("https://mrmovie.mrizki.com", "_blank")}
        />
        <TextArrow
          {...pointerEvents}
          onClick={() => window.open("https://mrmovie.mrizki.com", "_blank")}
          direction="DOWN"
          position={[0, -0.3, -0.2]}
          scale={1}
        >
          MrMovie
        </TextArrow>
      </group>
    </group>
  );
}
